"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabNavItem = void 0;
var _react = require("@emotion/react");
var _react2 = _interopRequireWildcard(require("react"));
var _IconCaretDown = _interopRequireDefault(require("../../../icons/General/IconCaretDown"));
var _Link = _interopRequireDefault(require("../../Link"));
var _TabContext = require("../TabContext");
var _useContainerDimensions = require("../utils/useContainerDimensions");
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @jsxImportSource @emotion/react */

const TabNavItem = ({
  value,
  displayText,
  trackingEvent,
  trackingName,
  className,
  isSelect,
  selected,
  selectItems
}) => {
  const theme = (0, _react.useTheme)();
  const childrenRef = /*#__PURE__*/_react2.default.createRef();
  const [open, setOpen] = _react2.default.useState(false);
  const {
    active,
    setActive,
    setWidth
  } = (0, _react2.useContext)(_TabContext.TabContext);
  const isActive = selected && selected === value || value === active;
  const ref = (0, _react2.useRef)(null);
  const {
    width,
    bottom,
    left
  } = (0, _useContainerDimensions.useContainerDimensions)(ref);
  (0, _react2.useEffect)(() => {
    const handleClickOutside = e => {
      const node = childrenRef.current;
      if (node && node.contains(e.target)) return;
      setOpen(false);
    };
    open ? document.addEventListener('mousedown', handleClickOutside) : document.removeEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, childrenRef]);
  (0, _react2.useEffect)(() => {
    if (width) setWidth({
      [value]: width
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);
  const onSelectClick = value => {
    setActive(value);
    setOpen(false);
  };
  return (0, _jsxRuntime.jsxs)(_react2.Fragment, {
    children: [(0, _jsxRuntime.jsxs)(_styles.TabNavItemWrapper, {
      ref: ref,
      onClick: () => isSelect ? setOpen(!open) : setActive(value),
      theme: theme,
      css: t => [isActive && _styles.styles.active(t)],
      "data-tracking-name": trackingName,
      "data-tracking-event": trackingEvent,
      className: className,
      children: [displayText ? displayText : value, isSelect && (0, _jsxRuntime.jsx)(_IconCaretDown.default, {
        flipVertical: open,
        size: 20
      })]
    }), isSelect && open && (0, _jsxRuntime.jsx)(_styles.SelectChildrenWrapper, {
      left: left,
      theme: theme,
      bottom: bottom,
      ref: childrenRef,
      minWidth: width,
      children: selectItems?.map(({
        displayText,
        value,
        onClick,
        indent,
        disabled
      }) => onClick ? (0, _jsxRuntime.jsx)(_styles.SelectOption, {
        tabIndex: 0,
        children: (0, _jsxRuntime.jsx)(_Link.default, {
          nopadding: true,
          onClick: onClick,
          children: displayText || value
        }, value)
      }, value) : (0, _jsxRuntime.jsx)(_styles.SelectOption, {
        bold: value === active,
        tabIndex: 0,
        indent: indent,
        disabled: disabled,
        onClick: !disabled ? () => onSelectClick(value) : undefined,
        children: displayText
      }, value))
    })]
  });
};
exports.TabNavItem = TabNavItem;
var _default = exports.default = TabNavItem;